window.setCandidate = () =>	 {
	toggleHow($("#candidate_where_we_met_input :checked").val());
	toggleExp();
	toggleLocPrefs($("#candidate_location_preference_input :checked").val());
	toggleExpHint($("#candidate_position_id").val());
}

window.showOther = (val) => {
	var howWeMet, directConnection = $("#candidate_where_we_met_dc").is(':checked');
	togglePronoun($("#candidate_pronoun").val());
	if (directConnection) {
		howWeMet = document.getElementById("candidate_how_we_met_dc").value;
	}
	else {
		howWeMet = document.getElementById("candidate_how_we_met_ol").value;
	}
	$("#candidate_heard_through_sm").hide();
	$("#candidate_heard_through_jb").hide();
	$("#candidate_heard_through_other_input").hide();
	$("#candidate_heard_through_university_input").hide();
	$("#candidate_heard_through_other").attr("placeholder", "");

	if (howWeMet == "University Visit") {
		$("#candidate_heard_through_university_input").show();		
	}
	else if (howWeMet == "Professional Organization or Meeting") {
		$("#candidate_heard_through_other_input").show();
		$("#candidate_heard_through_other").attr("placeholder", "e.g. TRB, ITE, ASCE, WTS, etc.")
	}
	else if (howWeMet == "Social Media") {
		$("#candidate_heard_through_sm").show();
	}
	else if (howWeMet == "Job Board") {
		$("#candidate_heard_through_jb").show();	
		if ($("#candidate_how_we_met_jb").val() == "Other") {
			$("#candidate_heard_through_other").attr("placeholder", "Which Job Board?")
			$("#candidate_heard_through_other_input").show();
		}
	}
	else if (howWeMet == "Other" || val == "Other") {
		$("#candidate_heard_through_other").attr("placeholder", "")
		$("#candidate_heard_through_other_input").show();
	}
	else if (directConnection && val != '') {
		$("#candidate_heard_through_other_input").show();
		$("#candidate_heard_through_other").attr("placeholder", "Which "+val+"?")
	}
}

/* This is for changes to the form when the candidate type is specified intern or full-time.  Different sets of questions are
displayed, AI confirmation, the offer to subscribe to the intern list will be added, and intern location preferences 
will appear when intern is checked.  Different questions and AI confirmation will appear when full-time gets checked. 

Additionally, interns always require a cover letter and sometimes full-time require a cover letter (when its a job posting
that requires it.)  So we use a hidden field that carries that value across invalid form posts, and adds/removes 
the required attributes to the input when the form re-renders after an invalid post. eg) a full-time candidate for a job posting
with a required cover letter, versus a normal full-time candidate cannot be differenated based on the other fields alone.

This function is called when the page renders, and when the intern radio input changes.  In order to check the value we filter
the type of input to [type=radio]:checked and read that value in the onchange handler.  Once its set as one or the other, the
field will be rendered as a hidden input on an invalid submit result so it won't change across multiple requests which would have
other problems such as the possibility of different sets of questions being answered, possibly with invalid answers, then hidden
from the view when changing the candidate type.  So we just prevent that situation.
*/
window.toggleExp = () => {
	if ( $('input[type=radio]:checked, input[type=hidden]','#candidate_intern_input').val() == 'true') {
		$('#candidate_intern_experience_input,#candidate_location_preference_input,#candidate_intern_list_subscribe_input,.ai_question,.intern-question').show();
		$('#candidate_full_time_experience_input,.full-question').hide();
	}
	else if ($('input[type=radio]:checked, input[type=hidden]','#candidate_intern_input').val() == 'false') {
		$('#candidate_full_time_experience_input,.ai_question,.full-question').show();
		$('#candidate_intern_experience_input,#candidate_intern_list_subscribe_input,#candidate_location_preference_input,.intern-question').hide();
	}
	if ($('#candidate_require_cover_letter_input').val() == 'true' || $('input[type=radio]:checked, input[type=hidden]','#candidate_intern_input').val() == 'true') {
		$("#candidate_cover_letter_input").addClass('required');
		$("#candidate_cover_letter_input").removeClass('optional');
		$("#candidate_cover_letter_input").find('label').text("Cover Letter");
		$("#candidate_cover_letter_input").find('label').append('<abbr title="required">*</abbr>');
	}
	else if ($('#candidate_require_cover_letter_input').val() == 'false' && $('input[type=radio]:checked, input[type=hidden]','#candidate_intern_input').val() == 'false') {
		$("#candidate_cover_letter_input").addClass('optional');
		$("#candidate_cover_letter_input").removeClass('required');
		$("#candidate_cover_letter_input").find('label').text("Cover Letter (Optional)");
		$("#candidate_cover_letter_input").find('label abbr').remove();
	}
}

window.toggleHow = (val) => {
	if (val == "dc") {
		$("#candidate_heard_through_dc").show()
		$("#candidate_heard_through_online").hide()
		showOther($("#candidate_how_we_met_dc").val())

	}
	else if (val == "ol") {
		$("#candidate_heard_through_online").show()
		$("#candidate_heard_through_dc").hide()
		showOther($("#candidate_how_we_met").val())
	}
}
window.togglePronoun = (val) => {
	if (val.startsWith("Other")) {
		$("#candidate_pronoun_other_input").show();
	}
	else {
		$("#candidate_pronoun_other_input").hide();
	}
}
window.toggleExpHint = (val) => {
	if (val == '1')
		$('#candidate_full_time_experience_input').find('p.inline-hints').text('Choose a range that reflects your full-time experience in the transportation field, excluding school work & internships');
	else
		$('#candidate_full_time_experience_input').find('p.inline-hints').text('Choose a range that reflects your full-time experience directly relevant to the position you\'re applying for, excluding school work & internships');
}
window.combineOptions = () => {
	var howWeMet, directConnection = $("#candidate_where_we_met_dc").is(':checked');
	if (directConnection) {
		howWeMet = document.getElementById("candidate_how_we_met_dc");
	}
	else {
		howWeMet = document.getElementById("candidate_how_we_met_ol");
	}
	var other = document.getElementById("candidate_heard_through_other");
	if (howWeMet.value == "Job Board") {
		var jobBoard = document.getElementById("candidate_how_we_met_jb");
		if (jobBoard.value == "Other") {
			howWeMet.options[howWeMet.selectedIndex].value = "Job Board: Other: "+other.value;
		}
		else {
			howWeMet.options[howWeMet.selectedIndex].value = "Job Board: "+jobBoard.value;
		}
	}
	else if (howWeMet.value == "Social Media") {
		var socialMed = document.getElementById("candidate_how_we_met_sm");
		howWeMet.options[howWeMet.selectedIndex].value = "Social Media: "+socialMed.value;
	}
	else if (howWeMet.value == "Other") {
		howWeMet.options[howWeMet.selectedIndex].value = "Other: "+other.value;
	}
	else if (directConnection) {
		if (howWeMet.value == "University Visit") {
			var heardUni = document.getElementById("candidate_heard_through_university");
			howWeMet.options[howWeMet.selectedIndex].value = "University Visit: "+heardUni.value;
		}
		else {
			var newVal = howWeMet.value+": "+other.value;
			howWeMet.options[howWeMet.selectedIndex].value = newVal;
		}
	}
	document.getElementById("candidate_how_we_met").value = howWeMet.value;

	if ($("#candidate_pronoun").val().startsWith("Other")) {
		var pronoun = document.getElementById("candidate_pronoun");
		pronoun.options[pronoun.selectedIndex].value = "Other: "+$("#candidate_pronoun_other").val()
	}
	var loc_pref = $("#candidate_location_preference_input :checked").val();
	if (loc_pref == "Specific")
		$("#candidate_location_details").val($("#candidate_specific_locations_input option:selected").toArray().map(item => item.text).join(", ") +"\n" + $("#candidate_specific_location_details_input textarea").val());
	else if (loc_pref == "Unsure")
		$("#candidate_location_details").val($("#candidate_unsure_locations_input textarea").val());
	else
		$("#candidate_location_details").val(null);
}
window.toggleLocPrefs = (val) => {
	if (val == "Specific") {
		$("#candidate_specific_locations_input,#candidate_specific_location_details_input").show();
		$("#candidate_unsure_locations_input").hide();
	}
	else if (val == "Unsure") {
		$("#candidate_unsure_locations_input").show();
		$("#candidate_specific_locations_input,#candidate_specific_location_details_input").hide();
	}
	else {
		$("#candidate_specific_locations_input,#candidate_unsure_locations_input,#candidate_specific_location_details_input").hide();
	}
}
